import { render, staticRenderFns } from "./sealrecord.vue?vue&type=template&id=13fdc8f2&scoped=true&"
import script from "./sealrecord.vue?vue&type=script&lang=js&"
export * from "./sealrecord.vue?vue&type=script&lang=js&"
import style0 from "./sealrecord.vue?vue&type=style&index=0&id=13fdc8f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fdc8f2",
  null
  
)

export default component.exports